import type { InvalidItemsError } from '@openx/components-core/lib/TransferList/bulk/types.ts';
import type { ConstValues } from '@openx/types/helpers.ts';

export type State = {
  value: string;
  errors: InvalidItemsError[];
  validItems: string[];
  isValidating: boolean;
  isResetEnabled: boolean;
};

export const BulkAction = {
  SetValue: 'SetValue',
  SetErrors: 'SetErrors',
  SetValidItems: 'SetValidItems',
  SetValidating: 'SetValidating',
  SetResetEnabled: 'SetResetEnabled',
  InitValues: 'InitValues',
} as const;
export type BulkAction = ConstValues<typeof BulkAction>;

export const Actions = {
  Validate: 'validate',
  Validating: 'validating',
  Reset: 'reset',
  Change_Handler: 'change_handler',
  SetResetEnabled: 'set_reset_enabled',
  SetValidating: 'set_validating',
} as const;
export type Actions = ConstValues<typeof Actions>;

export type Action =
  | {
      type: typeof Actions.Change_Handler;
      payload: {
        text: string;
      };
    }
  | {
      type: typeof Actions.Reset;
      payload: {
        formattedText: string;
      };
    }
  | {
      type: typeof Actions.Validate;
      payload: {
        errors: InvalidItemsError[];
        text: string;
        validItems: string[];
      };
    }
  | {
      type: typeof Actions.SetResetEnabled;
    }
  | {
      type: typeof Actions.SetValidating;
      payload: boolean;
    };

export const initialReducerState: State = {
  errors: [],
  isResetEnabled: true,
  isValidating: false,
  validItems: [],
  value: '',
};
